import api from "../api";

class InsuranceService {
	async findAllInsurance() {
		return new Promise((res, reject) => {
			return api
				.get("/insurance")
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	async findAllSubInsurance() {
		return new Promise((res, reject) => {
			return api
				.get("/insuranceSubTypes")
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	async updateSubInsurance(insurance) {
		return new Promise((res, reject) => {
			api
				.put("/insuranceSubTypes", insurance)
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	async updateInsurance(insurance) {
		return new Promise((res, reject) => {
			api
				.put("/insurance", insurance)
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	async createInsurance(insurance) {
		return new Promise((res, reject) => {
			api
				.post("/insurance", insurance)
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	async createSubInsurance(insurance) {
		return new Promise((res, reject) => {
			api
				.post("/insuranceSubTypes", insurance)
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	async deleteInsurance(id) {
		return new Promise((res, reject) => {
			api
				.delete("/insurance/" + id)
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	async deleteInsuranceSubType(id) {
		return new Promise((res, reject) => {
			api
				.delete("/insuranceSubTypes/" + id)
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	async createSubInsuranceDetails(insurance) {
		return new Promise((res, reject) => {
			api
				.post("/insuranceSubTypeDetails", insurance)
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	async findAllSubInsuranceDetails() {
		return new Promise((res, reject) => {
			return api
				.get("/insuranceSubTypeDetails")
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	async findAllSubInsuranceDetailsById(id) {
		return new Promise((res, reject) => {
			return api
				.get("/insuranceSubTypeDetails/" + id)
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	async findAllSubInsuranceDetailsBySubTypeId(id) {
		return new Promise((res, reject) => {
			return api
				.get("/insuranceSubTypeDetailsSID/" + id)
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	async updateSubInsuranceDetails(insurance) {
		return new Promise((res, reject) => {
			api
				.put("/insuranceSubTypeDetails", insurance)
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	async submitForVerification(orderId) {
		return new Promise((res, reject) => {
			api
				.get("/availityVerification/" + orderId)
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	async refreshCoverage(orderId) {
		return new Promise((res, reject) => {
			api
				.post("/refreshCoverage/" + orderId)
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	async refreshAvailityCoverage(orderId) {
		return new Promise((res, reject) => {
			api
				.post("/refreshAvailityCoverage/" + orderId)
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	async refreshPverifyCoverage(orderId) {
		return new Promise((res, reject) => {
			api
				.post("/refreshPverifyCoverage/" + orderId)
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	async refreshSameSim(orderId) {
		return new Promise((res, reject) => {
			api
				.post("/refreshSameSim/" + orderId)
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	async refreshSNF(orderId) {
		return new Promise((res, reject) => {
			api
				.post("/refreshSNF/" + orderId)
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}


}

const insuranceService = new InsuranceService();

export default insuranceService;
